module.exports = __webpack_public_path__ + "static/img/foot_soldier1.9acaeb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/foot_soldier1.png
// module id = arCk
// module chunks = 0